/**
 * "Start something" — up to four enabled flows as one-tap launch cards
 * straight into the new-run composer. The full catalog stays one click away.
 */
import { Notice } from '@evt/flow-stream-ui'
import type { PortalFlow } from '@portal/contracts'
import { Link, useNavigate } from 'react-router-dom'
import { useI18n } from '../../i18n'

const MAX_CARDS = 4

export function QuickFlows({ flows }: { flows: PortalFlow[] }) {
  const { t } = useI18n()
  const m = t.home
  const navigate = useNavigate()
  const launchable = flows.filter((f) => f.enabled).slice(0, MAX_CARDS)

  return (
    <section>
      <div className="home-section-head">
        <h2 className="home-section-title">{m.startSomething}</h2>
        <Link className="home-more" to="/flows">
          {m.allFlows} →
        </Link>
      </div>
      {launchable.length === 0 ? (
        <Notice kind="info">{m.noFlowsAvailable}</Notice>
      ) : (
        <div className="quick-grid">
          {launchable.map((flow) => (
            <button
              key={flow.flowId}
              type="button"
              className="quick-card card"
              onClick={() => navigate(`/flows/${encodeURIComponent(flow.flowId)}/new`)}
            >
              <span className="quick-card-text">
                <span className="quick-card-name">{flow.displayName}</span>
                {flow.description && <span className="quick-card-hint muted">{flow.description}</span>}
              </span>
              <span className="quick-card-play" aria-hidden>
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M6 4l14 8-14 8z" />
                </svg>
              </span>
            </button>
          ))}
        </div>
      )}
    </section>
  )
}
